import { useIsDarkPage, getThemedHref } from "@/hooks/useThemedHref";
import { booker, site } from "@/content";

export default function Footer() {
  const isDark = useIsDarkPage();

  return (
    <footer className="bg-gray-100 dark:bg-[#0A0A0A] border-t border-gray-200 dark:border-white/[0.09] relative overflow-hidden">
      {/* Subtle color blobs */}
      <div className="absolute top-0 left-0 w-[300px] h-[300px] rounded-full bg-yellow-200/30 dark:bg-yellow-500/10 blur-[100px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[250px] h-[250px] rounded-full bg-violet-200/25 dark:bg-violet-500/10 blur-[90px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 py-14 relative z-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Brand */}
          <div className="flex-1 max-w-xs">
            <a href={getThemedHref("/", isDark)} className="flex items-center gap-2.5 mb-4 cursor-pointer group">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-amber-600 dark:bg-amber-500 transition-all duration-300 group-hover:scale-110 group-hover:rotate-6 group-hover:bg-amber-500 dark:group-hover:bg-amber-400">
                <i className="ri-flashlight-line text-white dark:text-[#0C0C0E] text-sm transition-transform duration-300 group-hover:scale-110"></i>
              </div>
              <span className="font-extrabold text-lg tracking-tight text-gray-900 dark:text-white transition-colors duration-300 group-hover:text-amber-700 dark:group-hover:text-amber-300">
                Быстренко<span className="text-amber-600 dark:text-amber-500 transition-colors duration-300 group-hover:text-amber-700 dark:group-hover:text-amber-300">.ру</span>
              </span>
            </a>
            <p className="text-gray-500 dark:text-slate-400 text-sm leading-relaxed mb-5">{booker.footer.brandText}<br />
              ИП Быстренко А.В.&nbsp;ИНН 253711433438
            </p>
            <div className="flex gap-3">
              {site.socials.map((s) => (
                <a
                  key={s.key}
                  href={s.href}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-200 dark:bg-white/[0.06] text-gray-500 dark:text-slate-400 hover:bg-gradient-to-br hover:from-yellow-400 hover:to-red-400 hover:text-white transition-all cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {booker.footer.columns.map((col) => (
              <div key={col.title}>
                <div className="text-gray-900 dark:text-white font-semibold text-sm mb-4">{col.title}</div>
                <ul className="space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link.text}>
                      <a
                        href={link.href}
                        className="text-gray-500 dark:text-slate-400 text-sm hover:text-gray-900 hover:text-transparent hover:bg-gradient-to-r hover:from-yellow-400 hover:to-red-400 hover:bg-clip-text transition-all cursor-pointer"
                      >
                        {link.text}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-gray-200 dark:border-white/[0.09] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 dark:text-slate-400 text-xs">
            {booker.footer.copyright}
          </p>
          <div className="flex gap-5">
            <a href="/policy_pd.docx" className="text-gray-400 dark:text-slate-400 text-xs hover:text-gray-600 dark:hover:text-white/80 cursor-pointer">
              Политика обработки персональных данных
            </a>
            <a href="#" className="text-gray-400 dark:text-slate-400 text-xs hover:text-gray-600 dark:hover:text-white/80 cursor-pointer">
              Условия использования
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
